import Vue from 'vue';

const FETCH_VERSION = 'version/FETCH_VERSION';

const initialState = {
    version: ''
};

const actions = {
    fetchVersion({ commit }) {
        Vue.http.get(`${process.env.API}/api/operation/version`)
            .then(res => commit(FETCH_VERSION, res.body)).catch(error => {});
    }
};

const mutations = {
    [FETCH_VERSION](state, version) {
        state.version = version;
    }
};

const getters = {
    getVersion(state) {
        return state.version;
    }
};

export default {
    state: {
        ...initialState
    },
    actions,
    mutations,
    getters
};



// WEBPACK FOOTER //
// ./src/store/modules/version/index.js